import {
  PostprocessingEffectName,
  PostprocessingEffectProps,
} from "@/types/vault-object-filter-types";
import { HengeToneMappingEffect } from "@/engine/viewer/postprocessing/effects/HengeToneMappingEffect";
import { useEffect, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { EffectAttribute } from "postprocessing";

export function HengeToneMapping({
  strength = 1.0,
  ...props
}: PostprocessingEffectProps[typeof PostprocessingEffectName.ToneMapping] & {
  strength?: number;
}) {
  const effect = useMemo(
    () =>
      new HengeToneMappingEffect({
        ...props,
        strength,
      }),
    [props, strength],
  );
  useEffect(() => {
    effect.dispose();
  }, [effect]);

  return jsx("primitive", {
    ...props,
    object: effect,
    attributes: EffectAttribute.CONVOLUTION,
  });
}
